import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import PageRoutes from "../utils/routes";

const RequireAuth = ({ allowedRoles }) => {
  const { auth } = useAuth();
  const location = useLocation();

  return allowedRoles.includes(auth.role) ? (
    <Outlet />
  ) : auth?.accessToken ? ( //changed from user to accessToken to persist login after refresh
    <Navigate to={PageRoutes.unauthorized} state={{ from: location }} replace />
  ) : (
    <Navigate to={PageRoutes.login} state={{ from: location }} replace />
  );
};

export default RequireAuth;
